import { render, staticRenderFns } from "./button-group.vue?vue&type=template&id=78c3ed19&"
var script = {}
import style0 from "./button-group.vue?vue&type=style&index=0&id=78c3ed19&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports